<template lang="html">
  <img :src="picture.url" @error="updateUrl" :alt="alt">
</template>

<script>
import firebase from 'firebase'

export default {
  props: {
    picture: {
      type: [File, Object]
    },
    reference: {
      type: String
    },
    alt: {
      type: String
    }
  },
  data () {
    return {
      info: {
        url: null,
        ref: null
      }
    }
  },
  watch: {
    picture (picture) {
      if (!picture || !picture.url) {
        this.initPicture(this.reference)
      }
    },
    'picture.url' (url) {
      if (!url) {
        this.initPicture(this.reference)
      }
    },
    reference (reference) {
      if (!this.picture || !this.picture.url) {
        this.initPicture(reference)
      }
    }
  },
  mounted () {
    if (!this.picture || !this.picture.url) {
      this.initPicture(this.reference)
    }
  },
  methods: {
    initPicture (reference) {
      if (reference) {
        firebase.firestore()
          .doc(reference)
          .get((doc) => {
            if (doc.exists) {
              if ('picture' in doc.data()) {
                this.picture.url = doc.data().picture.url
                this.info.ref = doc.data().picture.ref
              } else {
                console.error('no picture field found !')
              }
            } else {
              console.error('doc not found')
            }
          })
      }
    },
    updateUrl () {
      if (this.reference && this.picture && this.picture.ref) {
        firebase.storage()
          .ref(this.info.ref)
          .getDownloadURL()
          .then((url) => {
            this.info.url = url
            firebase.firestore()
              .doc(this.reference)
              .update({
                picture: this.info
              })
          })
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Utils/Image.vue